<template>
  <div>
    <div class="contact-us" v-if="isMobile == 'pc'">
      <div class="contact-us-top">
        <!-- <div class="contact-us-top-img">
          <img :src="banner.imgUrl" alt="" width="100%">
        </div> -->
        <h2 style="text-align: center;padding-top: 2rem;">{{ $t('ContactUs') }}</h2>
        <div class="contact-us-list">
          <div class="contact-us-item" style="display: flex;align-items: center;justify-content: center;" :class="index%2 > 0 ?'contact-us-item-grey':''" v-for="(item,index) in addressList" :key="index">
            <el-row :gutter="10" style="width: 100%;">
              <el-col :span="screenWidth<=540?24:12" v-if="index%2 > 0 || screenWidth<=540">
                <MapContainer v-if="item.jwd" :jwd="item.jwd" :title="item.address"></MapContainer>
                <img v-else class="container" :src="item.imgUrl" alt="" width="100%">
              </el-col>
              <el-col :span="screenWidth<=540?24:12">
                <div>
                  <h3>{{ item.region }}</h3>
                  <div style="margin: 3rem 0;"><el-divider></el-divider></div>
                  <div style="line-height: 1.6rem;">
                    <div><i class="el-icon-location"></i>
                      <div class="contact-us-item-content">{{ $t('Address') }}：{{ item.address }} </div>
                    </div>
                    <div><i class="el-icon-message"></i>
                      <div class="contact-us-item-content">{{ $t('Email') }}： {{ item.email }} </div>
                    </div>
                    <div v-if="item.fax"><i class="el-icon-phone"></i>
                      <div class="contact-us-item-content">{{ $t('Fax') }}： {{ item.fax }} </div>
                    </div>
                  </div>
                </div>

              </el-col>
              <el-col :span="screenWidth<=540?24:12" v-if="index%2 <= 0 && screenWidth>540">
                <!-- <img :src="item.imgUrl" alt="" width="100%"> -->
                <MapContainer v-if="item.jwd" :jwd="item.jwd" :title="item.address"></MapContainer>
                <img v-else class="container" :src="item.imgUrl" alt="" width="100%">
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="contact-us" v-if="isMobile == 'mobile'">
      <div class="contact-us-top">
        <h2 style="text-align: center;padding-top: 2rem;">{{ $t('ContactUs') }}</h2>
        <div class="contact-us-list">
          <div class="contact-us-item-mobile" style="display: flex;flex-direction:column;align-items: center;justify-content: center;" v-for="(item,index) in addressList" :key="index">
            <div style="display:flex;width:96%;">
              <h3>{{ item.region }}</h3>
            </div>
            <el-row :gutter="10" style="width: 100%;">
              <el-col :span="screenWidth<=540?24:12" v-if="index%2 > 0 || screenWidth<=540">
                <MapContainer v-if="item.jwd" :jwd="item.jwd" :title="item.address"></MapContainer>
                <img v-else class="container" :src="item.imgUrl" alt="" width="100%">
              </el-col>
              <el-col :span="screenWidth<=540?24:12">
                <div>
                  <!-- <h3>{{ item.region }}</h3> -->
                  <div style="line-height: 1.6rem;">
                    <div style="padding-top:20px;"><i class="el-icon-location"></i>
                      <div class="contact-us-item-content">{{ $t('Address') }}：{{ item.address }} </div>
                    </div>
                    <div><i class="el-icon-message"></i>
                      <div class="contact-us-item-content">{{ $t('Email') }}： {{ item.email }} </div>
                    </div>
                    <div v-if="item.fax"><i class="el-icon-phone"></i>
                      <div class="contact-us-item-content">{{ $t('Fax') }}： {{ item.fax }} </div>
                    </div>
                  </div>
                  <div style="margin: 0 0 3rem;"><el-divider v-if="index != addressList.length - 1"></el-divider></div>
                </div>

              </el-col>
              <el-col :span="screenWidth<=540?24:12" v-if="index%2 <= 0 && screenWidth>540">
                <!-- <img :src="item.imgUrl" alt="" width="100%"> -->
                <MapContainer v-if="item.jwd" :jwd="item.jwd" :title="item.address"></MapContainer>
                <img v-else class="container" :src="item.imgUrl" alt="" width="100%">
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import { mapState } from 'vuex'

import MapContainer from '../../components/MapContainer'
import { listAddress, listBannerByModuleId } from '@/api/index';
export default {
  components: {
    MapContainer
  },
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      addressList: [],
      banner: {}
    }
  },
  mounted() {
    //联系我们地址
    this.getAddress()
    // this.getBanner()
  },
  methods: {
    getAddress() {
      listAddress().then(res => {
        if (res.data && res.data != null) {
          this.addressList = res.data;
        }
      })
    },
    getBanner() {
      const formData = new FormData();
      formData.append("moduleId", 8);
      listBannerByModuleId(formData).then(res => {
        if (res.data && res.data != null) {
          this.banner = res.data[0];
          console.log('this.banner', this.banner);
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.contact-us {
  background-color: white;
  .contact-us-top {
    width: 100%;
    // background-color: #fafafb;
    .contact-us-top-img {
    }
    .contact-us-top-introduce {
      width: 75%;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 3rem;
      // background-color: white;
      // border-radius: 0.5rem;
      font-size: 1rem;
      line-height: 2rem;
      h2 {
        text-align: center;
      }
    }
  }
  .contact-us-bottom {
    // background-color: #f6f6f6;
    width: 75%;
    margin: 3rem auto;
    box-sizing: border-box;
    .contact-us-bottom-title {
      height: 1.5rem;
      line-height: 1.5rem;
      .title-symbol {
        width: 100%;
        background-color: #2c4b8e;
        width: 1.3rem;
        height: 1.5rem;
        float: left;
      }
    }
  }
}
.jury-top {
  text-align: center;
  line-height: 1rem;
  .jury-top-introduce {
    line-height: 1.7rem;
    text-align: left;
    font-size: 0.9rem;
    font-weight: 500;
  }
}
::v-deep .el-divider--horizontal {
  margin: 1rem 0;
}

.contact-us-list {
  width: 100%;
  box-sizing: border-box;
  .contact-us-item {
    width: 100%;
    box-sizing: border-box;
    padding: 4rem 7%;
    .contact-us-item-content {
      position: relative;
      left: 2rem;
      top: -1.6rem;
      margin-right: 2rem;
    }
    img {
      vertical-align: middle;
      border-radius: 0.5rem;
    }
  }


  .contact-us-item-mobile {
    width: 100%;
    box-sizing: border-box;
    padding: 0 18px;
    .contact-us-item-content {
      position: relative;
      left: 2rem;
      top: -1.6rem;
      margin-right: 2rem;
    }
    img {
      vertical-align: middle;
      border-radius: 0.5rem;
    }
  }
  .contact-us-item-grey {
    background-color: #f8fafb;
  }
}
.container {
  width: 100% !important;
  height: 230px;
  border-radius: 1rem !important;
}
</style>